<!-- 改版导航 1.0 -->
<template>
    <div class="changeMenu" :style="{top: showAppTips ? '1.98rem' : '0.88rem'}">
        <div class="more_channel">
            <div class="title_box">
                <span class="title">更多频道</span>
                <span class="tips">点击进入频道</span>
            </div>
            <div class="channel_box">
                <a :href="item.url" class="item" v-for="(item, index) in channelArr" :key="index">{{item.name}}</a>
            </div>
        </div>
        <div class="recomment_box">
            <div class="title">
                <div class="left_title">为你推荐</div>
                <div class="more" @click="hideChangeMenu">更多</div>
            </div>
            <van-loading class="recommend_loading" v-if="request" vertical size="50">加载中...</van-loading>
            <a :href="item.newsurlm" class="item" v-for="(item, index) in recommendArr" :key="index">
                <div class="left_text">
                    <div class="item_title text-ellipses">{{item.subject}}</div>
                    <div class="time">{{datetime_fine_parse(item.newstime)}}</div>
                </div>
                <div class="right_cover">
                    <img :src="item.logourl" alt="">
                </div>
            </a>
        </div>
    </div>
</template>

<script>
import {datetime_fine_parse} from '@/common/js/tools'
import {getHotNewsByHours} from 'api/searchApi'
import {mapActions, mapGetters} from 'vuex'
export default {
    data() {
        return {
            channelArr: [
                {'name': '资讯', url: 'https://m.capwhale.com/'},
                {'name': '课堂', url: 'https://ke.capwhale.com/m/mindex'},
                {'name': '直播', url: 'https://live.capwhale.com/m/mliveindex'},
                {'name': '商学院', url: 'https://edu.capwhale.com/mzt/sxy/index.shtml'},
                {'name': '报告', url: 'https://report.capwhale.com/m/mreportindex'},
                {'name': '人才猎聘', url: 'https://hr.capwhale.com/m/mtalentindex'},
                {'name': '政府园区', url: 'https://parks.capwhale.com/mzt/parks/index.shtml'},
                {'name': '行业峰会', url: 'https://hd.capwhale.com/m/mkaa/index'}
            ],
            recommendArr: [],
            request: false
        }
    },
    props: ['isShowMenu'],
    // 生命周期 - 创建完成（访问当前this实例）
    created() {

    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {

    },
    methods: {
        getHotNewsByHours() {
            // this.setLoading(true)
            this.request = true
            getHotNewsByHours({
                data: {datacount: 10},
                success: res => {
                    // this.setLoading(false)
                    res.data.datalist.forEach((obj) => {
                        if (!obj.logourl) {
                            obj.logourl = require(`@/common/images/header/news/${this.createrandomNumber()}.jpg`)
                        }
                    })
                    this.recommendArr = res.data.datalist
                    this.request = false
                    console.log(res)
                },
                error: res => {
                    // this.setLoading(false)
                    this.request = false
                    this.$message.error(res.msg)
                }
            })
        },
        createrandomNumber() {
            return Math.floor(Math.random() * (40 - 1)) + 1
        },
        hideChangeMenu() {
            location.href = 'https://m.capwhale.com/'
            // this.$parent.openMenu()
        },
        ...mapActions([
            'setLoading'
        ])
    },
    computed: {
        datetime_fine_parse() {
            return datetime_fine_parse
        },
        ...mapGetters(['showAppTips'])
    },
    watch: {
        'isShowMenu': {
            handler(newV) {
                if (newV && !this.recommendArr.length) {
                    this.getHotNewsByHours()
                }
            },
            deep: true
        }
    }
}
</script>
<style scoped lang='scss'>
/* @import url(); 引入css类 */
@import "~common/scss/variable";
    .changeMenu {
        // border-top: 0.02rem solid $line;
        position: fixed;
        z-index: 2;
        // top: 0.88rem !important;
        right: 0;
        left:0;
        bottom: 0;
        background: #fff;
        overflow-y: auto;
        .more_channel {
            padding: 0.32rem 0.32rem 0;
            .title_box {
                margin-bottom: 0.32rem;
                .title {
                    font-size: 0.32rem;
                    font-weight: bold;
                    margin-right: 0.12rem;
                }
                .tips {
                    font-size: 0.24rem;
                    color: #999999;
                }
            }
            .channel_box {
                display: flex;
                align-items: center;
                justify-content: space-between;
                flex-wrap: wrap;
                .item {
                    display: block;
                    width: 1.54rem;
                    height: 0.8rem;
                    text-align: center;
                    line-height: 0.8rem;
                    background: #F1F2F3;
                    border-radius: 0.04rem;
                    font-size: 0.28rem;
                    margin-bottom: 0.32rem;
                    color: #333333;
                }
            }
        }
        .recomment_box {
            padding: 0 0.32rem;
            .title {
                display: flex;
                align-items: center;
                justify-content: space-between;
                .left_title {
                    font-size: 0.32rem;
                    font-weight: bold;
                    line-height: 0.45rem;
                }
                .more {
                    font-size: 0.24rem;
                    color: #999999;
                }
            }
            .recommend_loading {
                margin-top: 1.5rem;
            }
            .item {
                display: flex;
                padding: 0.32rem 0;
                border-bottom: 0.01rem solid #EEEEEE;
                .left_text {
                    margin-right: 0.2rem;
                    width: 4.12rem;
                    .item_title {
                        font-size: 0.28rem;
                        margin-bottom: 0.22rem;
                        line-height: 0.4rem;
                        color: #333333;
                    }
                    .time {
                        font-size: 0.24rem;
                        color: #999999;
                    }
                }
                .right_cover {
                    width: 2.54rem;
                    height: 1.44rem;
                    img {
                        width: 2.54rem;
                        height: 1.44rem;
                        border-radius: 0.06rem;
                    }
                }
            }
        }
    }
</style>